import React from 'react';
import Lottie from 'react-lottie';
import animationData from './animation/wired-outline-Success green color-approved-checked.json'

const AnimationComponent = () => {
    // Lottie animation options
    const defaultOptions = {
      loop: false,          // Whether the animation should loop
      autoplay: true,      // Whether the animation should play automatically
      animationData: animationData, // Your downloaded Lottie JSON file
    };
  
    return (
      <div>
        <Lottie options={defaultOptions} height={80} width={80} />
      </div>
    );
  };
  
  export default AnimationComponent;
  